<div
  *ngIf="open"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4 py-8"
  (click)="close.emit()"
>
  <div
    class="w-full max-w-3xl rounded-[28px] bg-white shadow-2xl overflow-hidden"
    (click)="$event.stopPropagation()"
    role="dialog"
    aria-modal="true"
  >
    <div class="p-6 sm:p-8">
      <div *ngIf="loading" class="py-12">
        <div class="flex flex-col items-center gap-3">
          <div
            class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
          ></div>
          <p class="text-sm font-medium text-slate-500">
            Loading vendor details...
          </p>
        </div>
      </div>

      <ng-container *ngIf="!loading && vendor">
      <div class="rounded-3xl bg-sky-50 p-6 sm:p-7 border border-sky-100">
        <div class="flex items-start justify-between gap-4">
          <div class="flex items-start gap-4">
            <div class="size-14 rounded-2xl bg-white border border-slate-200 grid place-items-center text-vms-bg-secondary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" class="h-8 w-8">
                <path d="M4 21V7a2 2 0 0 1 2-2h6l2 2h4a2 2 0 0 1 2 2v12"></path>
                <path d="M8 21v-8"></path>
                <path d="M12 21v-8"></path>
              </svg>
            </div>

            <div class="min-w-0">
              <app-page-header
                [title]="vendor.name"
                [subtitle]="vendor.vendorReference + ' | ASIN-' + (vendor.asin || 'N/A')"
              ></app-page-header>

              <div class="mt-3 flex flex-wrap items-center gap-3 text-sm text-slate-600">
                <span class="inline-flex items-center rounded-full bg-white px-4 py-1.5 border border-slate-200">
                  {{ vendor.categoryName || 'N/A' }}
                </span>
                <span class="ml-auto text-sm text-slate-600">
                  Registered: {{ formatDate(vendor.createdAt) }}
                </span>
              </div>
            </div>
          </div>

          <span
            class="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-medium"
            [ngClass]="statusPillClass(vendor.approvalStatus)"
          >
            {{ vendor.approvalStatus || 'PENDING' }}
          </span>
        </div>
      </div>

      <div class="mt-6 flex flex-wrap gap-3">
        <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'overview'" (click)="setTab('overview')">
          Overview
        </button>
        <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'directors'" (click)="setTab('directors')">
          Directors
        </button>
        <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'bank'" (click)="setTab('bank')">
          Bank Details
        </button>
        <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'documents'" (click)="setTab('documents')">
          Documents
        </button>
      </div>

      <div class="mt-5 rounded-3xl border border-slate-200 bg-white p-6 sm:p-7">
        <ng-container [ngSwitch]="tab">
          <div *ngSwitchCase="'overview'" class="space-y-5">
            <div class="kv">
              <span class="kv__key">Phone</span>
              <span class="kv__value">{{ vendor.phoneNo || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Email</span>
              <span class="kv__value">{{ vendor.email || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Address</span>
              <span class="kv__value">{{ vendor.address || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">RC Number</span>
              <span class="kv__value">{{ vendor.rcNumber || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Business Classification</span>
              <span class="kv__value">{{ vendor.businessClassification || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Date of Incorporation</span>
              <span class="kv__value">{{ vendor.dateOfIncorporation || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">TIN</span>
              <span class="kv__value">{{ vendor.tin || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">MDA Association</span>
              <span class="kv__value">{{ vendor.mdaName || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Nature of Service</span>
              <span class="kv__value">{{ vendor.natureOfService || 'N/A' }}</span>
            </div>
          </div>

          <div *ngSwitchCase="'directors'" class="space-y-6">
            <div
              *ngFor="let director of vendor.directors ?? []; let i = index; trackBy: trackByIndex"
              class="rounded-2xl border border-slate-200 bg-white p-6"
            >
              <h3 class="text-lg font-semibold text-slate-800">Director {{ i + 1 }}</h3>
              <div class="mt-5 space-y-4">
                <div class="kv">
                  <span class="kv__key">ASIN</span>
                  <span class="kv__value">{{ director.asin || 'N/A' }}</span>
                </div>
                <div class="kv">
                  <span class="kv__key">Name</span>
                  <span class="kv__value">{{ director.name || 'N/A' }}</span>
                </div>
                <div class="kv">
                  <span class="kv__key">Phone Number</span>
                  <span class="kv__value">{{ director.phone || 'N/A' }}</span>
                </div>
                <div class="kv">
                  <span class="kv__key">Email</span>
                  <span class="kv__value">{{ director.email || 'N/A' }}</span>
                </div>
                <div class="kv">
                  <span class="kv__key">Address</span>
                  <span class="kv__value">{{ director.address || 'N/A' }}</span>
                </div>
                <div class="kv">
                  <span class="kv__key">BVN</span>
                  <span class="kv__value">{{ maskBvn(director.bvn) }}</span>
                </div>
              </div>
            </div>

            <div *ngIf="(vendor.directors?.length ?? 0) === 0" class="text-sm text-slate-500">
              No directors available.
            </div>
          </div>

          <div *ngSwitchCase="'bank'" class="space-y-5">
            <div class="kv">
              <span class="kv__key">Account Number</span>
              <span class="kv__value">{{ vendor.bankDetails?.accountNumber || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Account Name</span>
              <span class="kv__value">{{ vendor.bankDetails?.accountName || 'N/A' }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Bank</span>
              <span class="kv__value">{{ vendor.bankDetails?.bankName || 'N/A' }}</span>
            </div>
          </div>

	          <div *ngSwitchCase="'documents'" class="space-y-4">
	            <div
	              *ngFor="let doc of vendor.documents ?? []; trackBy: trackByIndex"
	              class="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4"
	            >
	              <div class="flex min-w-[240px] items-center gap-4">
	                <div class="h-10 w-10 rounded-xl bg-slate-50 grid place-items-center border border-slate-200">
	                  <span class="text-xs font-semibold text-red-500">PDF</span>
	                </div>
	                <div class="min-w-0">
                    	                    <!-- (click)="!doc.uploaded_document_url && $event.preventDefault()" -->
	                  <a
	                    class="page-link truncate"
	                    [href]="doc.uploaded_document_url || '#'"
	                    target="_blank"
	                    rel="noopener noreferrer"
	                  >{{ doc.name }}</a>
	                  <div class="mt-1 text-sm text-slate-400">Uploaded: {{ doc.uploadedAt }}</div>
	                </div>
	              </div>

              <ng-container *ngIf="(vendor.approvalStatus || '').toUpperCase() === 'APPROVED'; else pendingPill">
                <span
                  class="inline-flex items-center rounded-full bg-sky-100 px-4 py-1.5 text-sm font-medium text-sky-700"
                >
                  Verified
                </span>
              </ng-container>
              <ng-template #pendingPill>
                <span
                  class="inline-flex items-center rounded-full bg-amber-100 px-4 py-1.5 text-sm font-medium text-amber-700"
                >
                  Pending
                </span>
              </ng-template>
            </div>

            <div *ngIf="(vendor.documents?.length ?? 0) === 0" class="text-sm text-slate-500">
              No documents uploaded.
            </div>
          </div>
        </ng-container>
      </div>

      <button
        type="button"
        class="mt-7 w-full rounded-2xl bg-red-50 px-6 py-4 text-center text-base font-semibold text-red-600 hover:bg-red-100 transition"
        (click)="close.emit()"
      >
        Close
      </button>
      </ng-container>
    </div>
  </div>
</div>
